import Wizard, { WizardStepConfig } from "@/components/shared/Wizard/Wizard";
import NewPasswordStep from "./NewPasswordStep";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@/components/primitives/dialog";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/primitives/button";
import ShowPasswordStep from "../ForgotPassword/ShowPasswordStep";
import WordsStep from "../RecoveryKey/WordsStep";
import ConfirmPhraseChangeStep from "./ConfirmPhraseChangeStep";
import ConfirmPhraseForgotStep from "../ForgotPassword/ConfirmPhraseForgotStep";

export default function ChangePasswordWizard() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const steps: WizardStepConfig[] = [
    {
      name: "ChangePassword",
      dataKey: "userData",
      component: NewPasswordStep,
    },
    {
      name: "RecoveryPhrase",
      dataKey: "password",
      component: ConfirmPhraseForgotStep,
    },
    {
      name: "ShowPassword",
      dataKey: "showPassword",
      component: ShowPasswordStep,
    },
    {
      name: "Words",
      dataKey: "words",
      component: WordsStep,
    },
    {
      name: "NewRecoveryPhrase",
      dataKey: "newPassword",
      component: ConfirmPhraseChangeStep,
    },
    {
      name: "ShowPassword",
      dataKey: "showPassword",
      component: ShowPasswordStep,
    },
  ];

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="font-normal">
          {t("changePassword.title")}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="h-full min-w-full p-6 md:h-auto md:min-w-[43rem]"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogTitle className="hidden" />
        <DialogDescription className="hidden" />
        <Wizard steps={steps} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
